"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.DefaultHotspotStyled = exports.TextBoxStyled = exports.TextBoxMask = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // $FlowFixMe


var animateTextBox = (0, _styledComponents.keyframes)(["from{transform:translate(-120%,0);}to{transform:translate(0,0);}"]);

var TextBoxMask = _styledComponents.default.div.withConfig({
  displayName: "DefaultHotspotstyles__TextBoxMask",
  componentId: "s7tza4-0"
})(["left:100%;top:0;position:absolute;display:flex;overflow:hidden;"]);

exports.TextBoxMask = TextBoxMask;

var TextBoxStyled = _styledComponents.default.span.withConfig({
  displayName: "DefaultHotspotstyles__TextBoxStyled",
  componentId: "s7tza4-1"
})(["background:", ";border:1px solid ", ";color:", ";font-size:2em;margin-left:0.5em;min-width:4em;padding:0.5em;position:relative;text-align:center;white-space:nowrap;transition:transform 4.35s cubic-bezier(0.16,1,0.3,1);animation:", " 0.45s 0.4s cubic-bezier(0.16,1,0.3,1);animation-fill-mode:backwards;"], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, _hotspotGlobal.colors.white, function (_ref2) {
  var textColor = _ref2.textColor;
  return textColor;
}, animateTextBox);

exports.TextBoxStyled = TextBoxStyled;
var animateSize = (0, _styledComponents.keyframes)(["0%{width:0;height:0;}50%{width:0;height:100%;}100%{width:100%;height:100%;}"]);
var animateColor = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:100%;}"]);
var transitionSpeed = 0.3;

var DefaultHotspotStyled = _styledComponents.default.div.withConfig({
  displayName: "DefaultHotspotstyles__DefaultHotspotStyled",
  componentId: "s7tza4-2"
})(["height:100%;width:100%;position:relative;&::before,&::after{box-sizing:inherit;content:'';position:absolute;border:", ";width:0;height:0;}&::before{top:0;left:0;border-left-color:", ";border-bottom-color:", ";animation:", " ", "s ease-in;animation-fill-mode:forwards;}&::after{bottom:0;right:0;opacity:0;border-right-color:", ";border-top-color:", ";animation:", " ", "s ease-out 0.3s,", " 0s 0.3s;animation-fill-mode:forwards;}"], function (_ref3) {
  var _ref3$config = _ref3.config,
      borderStyle = _ref3$config.borderStyle,
      borderWidth = _ref3$config.borderWidth;
  return "".concat(parseInt(borderWidth, 10), "px ").concat(borderStyle, " transparent");
}, function (_ref4) {
  var borderColor = _ref4.config.borderColor;
  return borderColor;
}, function (_ref5) {
  var borderColor = _ref5.config.borderColor;
  return borderColor;
}, animateSize, transitionSpeed, function (_ref6) {
  var borderColor = _ref6.config.borderColor;
  return borderColor;
}, function (_ref7) {
  var borderColor = _ref7.config.borderColor;
  return borderColor;
}, animateSize, transitionSpeed, animateColor);

exports.DefaultHotspotStyled = DefaultHotspotStyled;

var hoverState = function hoverState(_ref8) {
  var backgroundColor = _ref8.backgroundColor,
      borderColor = _ref8.borderColor,
      borderStyle = _ref8.borderStyle,
      borderWidth = _ref8.borderWidth,
      color = _ref8.color,
      opacity = _ref8.opacity;
  return "\n  ".concat(DefaultHotspotStyled, " {\n    &::before, &::after {\n      border: ").concat(parseInt(borderWidth, 10), "px ").concat(borderStyle, " ").concat(borderColor, ";\n      opacity: ").concat(opacity, ";\n    }\n  }\n\n  ").concat(TextBoxStyled, " {\n    background: ").concat(backgroundColor, ";\n    color: ").concat(color, ";\n  }\n");
};

var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "DefaultHotspotstyles__ClickableAreaStyled",
  componentId: "s7tza4-3"
})(["", ""], function (_ref9) {
  var disableHover = _ref9.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", ";}", ""], _hotspot.focusVisible, function (_ref10) {
    var hoverStyle = _ref10.hoverStyle;
    return hoverState(hoverStyle);
  }, function (_ref11) {
    var hoverStyle = _ref11.hoverStyle,
        previewHoverState = _ref11.previewHoverState;
    return previewHoverState && hoverState(hoverStyle);
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;